import { NavLink } from "react-router-dom";
import { LayoutDashboard, CheckSquare, Wallet, MessageSquare, Map } from "lucide-react";
import { motion } from "framer-motion";

import { cn } from "@/lib/utils";

const items = [
  { to: "/portal", end: true, label: "Home", icon: LayoutDashboard },
  { to: "/portal/tasks", label: "Lavori", icon: CheckSquare },
  { to: "/portal/roadmap", label: "Percorso", icon: Map },
  { to: "/portal/finance", label: "Conti", icon: Wallet },
  { to: "/portal/requests", label: "Richieste", icon: MessageSquare },
];

/**
 * Navigazione da pollice: solo sotto md, target ≥44px (§8).
 *
 * La riga ha altezza fissa e la safe area sta sotto, non dentro: sommate
 * nello stesso `h-16` la barra si schiacciava sugli iPhone con home bar.
 */
export function PortalBottomNav() {
  return (
    <nav
      aria-label="Navigazione rapida"
      className="fixed inset-x-0 bottom-0 z-40 border-t border-white/[0.08] bg-card-2/90 backdrop-blur-xl md:hidden"
      style={{ paddingBottom: "var(--safe-bottom)" }}
    >
      <span aria-hidden className="absolute inset-x-0 top-0 h-px bg-gradient-brand opacity-50" />
      <div className="flex" style={{ height: "var(--bottom-nav-row)" }}>
        {items.map((it) => (
          <NavLink
            key={it.to}
            to={it.to}
            end={it.end}
            className="relative flex min-w-0 flex-1 select-none flex-col items-center justify-center gap-1 px-0.5 transition-transform duration-fast ease-palazzo focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-inset focus-visible:ring-ring active:scale-95"
          >
            {({ isActive }) => (
              <>
                {isActive && (
                  <motion.span
                    aria-hidden
                    layoutId="portal-bottomnav-active"
                    className="absolute inset-x-1.5 top-1 h-9 rounded-xl bg-primary/[0.12] shadow-[inset_0_0_0_1px_hsl(var(--primary)/0.22)]"
                    transition={{ type: "spring", stiffness: 380, damping: 30 }}
                  />
                )}
                <it.icon
                  aria-hidden
                  className={cn(
                    "relative z-10 h-[22px] w-[22px] shrink-0 transition-colors duration-fast ease-palazzo",
                    isActive ? "text-primary" : "text-muted-foreground",
                  )}
                />
                <span
                  className={cn(
                    "relative z-10 w-full truncate px-0.5 text-center text-[11px] font-medium leading-none transition-colors duration-fast ease-palazzo",
                    isActive ? "text-primary" : "text-muted-foreground",
                  )}
                >
                  {it.label}
                </span>
              </>
            )}
          </NavLink>
        ))}
      </div>
    </nav>
  );
}
